import { createApp } from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'

import ElementPlus from 'element-plus'
import eventBus from 'vue3-eventbus'
import './styles/element/index.scss'
import zhCn from 'element-plus/es/locale/lang/zh-cn'

createApp(App)
    .use(store)
    .use(router)
    .use(eventBus)
    .use(ElementPlus, { locale: zhCn })
    .mount('#app')
